module.exports = "/_next/static/images/Sergiu_Chitanu-b3a0262127941f8237d22c5d434b355e.webp";